import { extendTheme } from "@chakra-ui/react"

const theme = extendTheme({
  colors: {
    brand: {
      50: "#e8f3f0",
      100: "#c9e2dc",
      500: "#287a70",
      600: "#1f655d",
      700: "#184f49",
      800: "#123c38",
      900: "#0c2927",
    },
    ink: "#172624",
    paper: "#f6f3ed",
  },
  fonts: {
    heading:
      '"PingFang TC", "Noto Sans TC", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    body:
      '"PingFang TC", "Noto Sans TC", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
  },
  styles: {
    global: {
      "html, body": {
        background: "paper",
        color: "ink",
      },
      body: {
        minHeight: "100vh",
      },
      "::selection": {
        background: "brand.100",
        color: "brand.900",
      },
      "*:focus-visible": {
        outline: "3px solid",
        outlineColor: "brand.500",
        outlineOffset: "3px",
      },
      "@media (prefers-reduced-motion: no-preference)": {
        "@keyframes content-in": {
          from: {
            opacity: 0.96,
            transform: "translateY(6px)",
          },
          to: {
            opacity: 1,
            transform: "translateY(0)",
          },
        },
        "#main-content": {
          animation: "content-in 520ms cubic-bezier(0.16, 1, 0.3, 1)",
        },
      },
    },
  },
  components: {
    Button: {
      baseStyle: {
        borderRadius: "10px",
        fontWeight: "700",
      },
    },
    Link: {
      baseStyle: {
        textUnderlineOffset: "3px",
      },
    },
  },
})

export default theme
